var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as baobab from '@data/baobab/baobab';
import { setInitializer } from '@data/rest/RESTWrapper.js';
import { ApiKeysApi, Configuration, UsersApi, UserGroupsApi, VersionsApi, FarseerFilesApi, SettingsApi, DocumentsApi, GridsApi, WidgetsApi, TagsApi, TableTagRelationsApi, CellsApi, TimePointsApi, ImportJobsApi, WorkerJobsApi, ExportApi, AuditLogsApi, EvaluatorApi, BackpropApi, ForecastApi, EngineApi, UpdateCellWithTransformRequestValueTransformTypeEnum, ExportConfigurationsApi, RemoteJobsApi, RemoteJobRunsApi, UserActivityApi, DataEntryLinksApi, MessageThreadsApi, MaintenanceApi, SheetRowsApi, } from '@common/api';
import toast from 'react-hot-toast';
import eventEmiter from '../../base/Emitter';
export var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["POST"] = "POST";
    Method["PUT"] = "PUT";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
function defaultUnauthorizedHandler() {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            window.location.href = '/';
            return [2 /*return*/];
        });
    });
}
var RequestContextImpl = /** @class */ (function () {
    function RequestContextImpl() {
        this._requestInitializers = [];
        this._unauthorizedHandler = defaultUnauthorizedHandler;
        this._defaultHeaders = new Map([
            ['Content-Type', 'application/json'],
            ['Accept', 'application/json'],
        ]);
    }
    Object.defineProperty(RequestContextImpl.prototype, "unauthorizedHandler", {
        get: function () {
            return this._unauthorizedHandler;
        },
        set: function (handler) {
            this._unauthorizedHandler = handler;
        },
        enumerable: false,
        configurable: true
    });
    RequestContextImpl.prototype.addRequestInitializer = function (initializer) {
        this._requestInitializers.push(initializer);
    };
    RequestContextImpl.prototype.initializeRequest = function (httpRequest, addDefaults) {
        return __awaiter(this, void 0, Promise, function () {
            var _a, _b, _c, name, value, _d, _e, initializer, e_1_1;
            var e_2, _f, e_1, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (addDefaults === undefined || addDefaults === null) {
                            addDefaults = true;
                        }
                        if (addDefaults) {
                            try {
                                for (_a = __values(this._defaultHeaders), _b = _a.next(); !_b.done; _b = _a.next()) {
                                    _c = __read(_b.value, 2), name = _c[0], value = _c[1];
                                    if (!httpRequest.headers.get(name)) {
                                        httpRequest.headers.set(name, value);
                                    }
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 6, 7, 8]);
                        _d = __values(this._requestInitializers), _e = _d.next();
                        _h.label = 2;
                    case 2:
                        if (!!_e.done) return [3 /*break*/, 5];
                        initializer = _e.value;
                        return [4 /*yield*/, initializer(httpRequest)];
                    case 3:
                        _h.sent();
                        _h.label = 4;
                    case 4:
                        _e = _d.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _h.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_e && !_e.done && (_g = _d.return)) _g.call(_d);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    RequestContextImpl.prototype.setDefaultHeader = function (name, value) {
        this._defaultHeaders.set(name, value);
    };
    return RequestContextImpl;
}());
export var requestContext = new RequestContextImpl();
setInitializer(requestContext);
var CustomError = /** @class */ (function (_super) {
    __extends(CustomError, _super);
    function CustomError(message, extra) {
        var _this = _super.call(this, message) || this;
        _this.extra = extra;
        return _this;
    }
    return CustomError;
}(Error));
export function request(method, url, payload) {
    return __awaiter(this, void 0, Promise, function () {
        var request, response, status, errObject, errString;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        method: method,
                        headers: new Headers(),
                        body: payload ? JSON.stringify(payload) : undefined,
                    };
                    return [4 /*yield*/, requestContext.initializeRequest(request)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetch(url, request)];
                case 2:
                    response = _a.sent();
                    status = response.status;
                    if (!(status === 401)) return [3 /*break*/, 4];
                    return [4 /*yield*/, requestContext.unauthorizedHandler()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4:
                    if (!(status < 200 || status > 299)) return [3 /*break*/, 6];
                    return [4 /*yield*/, response.json()];
                case 5:
                    errObject = _a.sent();
                    errString = errObject && errObject.data && errObject.data.message ? errObject.data.message : 'Something went wrong.';
                    if (errObject.data && errObject.data.extra) {
                        throw new CustomError(errString, errObject.data.extra);
                    }
                    throw new Error(errString);
                case 6: return [4 /*yield*/, response.json()];
                case 7: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function uploadFile(url, file) {
    return __awaiter(this, void 0, void 0, function () {
        var formData, request, response, json, errString;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    formData = new FormData();
                    formData.append('file', file);
                    request = {
                        method: Method.POST,
                        headers: new Headers(),
                        body: formData,
                    };
                    return [4 /*yield*/, requestContext.initializeRequest(request, false)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetch(url, request)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    json = _a.sent();
                    if (response.status !== 200) {
                        errString = json && json.data && json.data.message ? json.data.message : 'Something went wrong.';
                        throw new Error(errString);
                    }
                    return [2 /*return*/, json];
            }
        });
    });
}
export function downloadFile(method, url, fileName, payload) {
    if (fileName === void 0) { fileName = 'filename.xlsx'; }
    return __awaiter(this, void 0, void 0, function () {
        var request, response, message, blob, fileUrl, a;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        method: method,
                        headers: new Headers(),
                        body: payload ? JSON.stringify(payload) : undefined,
                    };
                    return [4 /*yield*/, requestContext.initializeRequest(request)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetch(url, request)];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.text()];
                case 3:
                    message = _a.sent();
                    toast.error('Error when downloading file');
                    console.error(message);
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, response.blob()];
                case 5:
                    blob = _a.sent();
                    fileUrl = window.URL.createObjectURL(blob);
                    a = document.createElement('a');
                    a.href = fileUrl;
                    a.download = fileName;
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                    a.remove(); //afterwards we remove the element again
                    return [2 /*return*/];
            }
        });
    });
}
export function downloadFileViaBlob(blob, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var fileUrl, a;
        return __generator(this, function (_a) {
            fileUrl = window.URL.createObjectURL(blob);
            a = document.createElement('a');
            a.href = fileUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            return [2 /*return*/];
        });
    });
}
export function getObject(endpoint, baobabPath) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(Method.GET, endpoint)];
                case 1:
                    res = _a.sent();
                    baobab.root.select(baobabPath).set(res.data);
                    return [2 /*return*/, res.data];
            }
        });
    });
}
export function getObjectWithApi(id, api, baobabPath) {
    return __awaiter(this, void 0, void 0, function () {
        var object;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.get(id)];
                case 1:
                    object = _a.sent();
                    baobab.root.select(baobabPath).set(object);
                    return [2 /*return*/, object];
            }
        });
    });
}
export function createObject(endpoint, object, baobabPath) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request(Method.POST, '/api/importJobs2', object)];
                case 1:
                    response = _a.sent();
                    if (baobabPath) {
                        baobab.root.select(baobabPath).push(response.data);
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
}
var apiMiddlewares = [
    {
        post: function (context) {
            return __awaiter(this, void 0, void 0, function () {
                var message, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (context.response.status !== 401) {
                                eventEmiter.emit('unauthorized', false);
                            }
                            else {
                                eventEmiter.emit('unauthorized', true);
                            }
                            if (!(context.response.status !== 503)) return [3 /*break*/, 1];
                            eventEmiter.emit('maintenance', false);
                            return [3 /*break*/, 4];
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, context.response.json()];
                        case 2:
                            message = _a.sent();
                            if (message.code === 0) {
                                eventEmiter.emit('maintenance', true);
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
    },
];
export function addMiddleware(middleware) {
    apiMiddlewares.push(middleware);
}
var config = new Configuration({
    middleware: apiMiddlewares,
    basePath: '/api/v3',
});
export var cellsApi = new CellsApi(config);
export var documentsApi = new DocumentsApi(config);
export var engineApi = new EngineApi(config);
export var exportApi = new ExportApi(config);
export var farseerFilesApi = new FarseerFilesApi(config);
export var gridsApi = new GridsApi(config);
export var workerJobsApi = new WorkerJobsApi(config);
export var settingsApi = new SettingsApi(config);
export var tagsApi = new TagsApi(config);
export var tagRelationsApi = new TableTagRelationsApi(config);
export var userGroupsApi = new UserGroupsApi(config);
export var usersApi = new UsersApi(config);
export var versionsApi = new VersionsApi(config);
export var widgetsApi = new WidgetsApi(config);
export var timePointsApi = new TimePointsApi(config);
export var importJobsApi = new ImportJobsApi(config);
export var auditLogsApi = new AuditLogsApi(config);
export var remoteJobsApi = new RemoteJobsApi(config);
export var remoteJobRunsApi = new RemoteJobRunsApi(config);
export var evaluatorApi = new EvaluatorApi(config);
export var backpropApi = new BackpropApi(config);
export var forecastApi = new ForecastApi(config);
export var exportConfigurationsApi = new ExportConfigurationsApi(config);
export var apiKeysApi = new ApiKeysApi(config);
export var userActivityApi = new UserActivityApi(config);
export var entryLinksApi = new DataEntryLinksApi(config);
export var messageThreadsApi = new MessageThreadsApi(config);
export var maintenanceApi = new MaintenanceApi(config);
export var sheetRowsApi = new SheetRowsApi(config);
export var apiVersionApi = {
    get: function () {
        return request(Method.GET, '/api/version');
    },
};
window.test = function (rows, cols) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, evaluatorApi.evaluate({ rows: rows, cols: cols })];
                case 1:
                    res = _a.sent();
                    console.log('res: ', res);
                    return [2 /*return*/];
            }
        });
    });
};
window.inv = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, evaluatorApi.invalidateCache()];
                case 1:
                    _a.sent();
                    console.log('invalidated');
                    return [2 /*return*/];
            }
        });
    });
};
window.sim = function (value, tagIdTransform, sourceTagIds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, cellsApi.updateBatchWithTransform([
                        {
                            valueTransformType: UpdateCellWithTransformRequestValueTransformTypeEnum.Mul,
                            value: value,
                            tagIdTransform: tagIdTransform,
                            sourceTagIds: sourceTagIds,
                        },
                    ])];
                case 1:
                    _a.sent();
                    console.log('done');
                    return [2 /*return*/];
            }
        });
    });
};
window.cleanTags = function () {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('cleaning tags...');
                    return [4 /*yield*/, cellsApi.cleanTags()];
                case 1:
                    _a.sent();
                    console.log('done');
                    return [2 /*return*/];
            }
        });
    });
};
window.copyCells = function (req) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('copying cells...');
                    return [4 /*yield*/, cellsApi.copyCells(req)];
                case 1:
                    _a.sent();
                    console.log('done');
                    return [2 /*return*/];
            }
        });
    });
};
